import {Container, styled} from "@mui/material";


export const StyledContainer = styled(Container)`
  margin-top: 10px;
`